<template>
  <div class="table-responsive">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div>
      <p><strong>Número de Recibo: </strong> {{movimiento.numeroRecibo !== null ? movimiento.numeroRecibo : movimiento.idRecibo}}</p>
    </div>
    <b-table-simple>
      <b-thead class="columnas">
        <b-tr>
          <b-th class="text-center">Tratamiento</b-th>
          <b-th class="text-center">OD</b-th>
          <b-th class="text-center"># Sesión</b-th>
          <b-th class="text-center">Forma de Pago</b-th>
          <b-th class="text-center">Terminal</b-th>
          <b-th class="text-center">MSI</b-th>
          <b-th class="text-center">% comisión</b-th>
          <b-th class="text-center">Importe comisión</b-th>
          <b-th class="text-center">Importe IVA</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="(tratamiento, index) in movimiento.tratamientosProgramados" :key="index">
          <b-td class="text-center">
            {{tratamiento.nombre}}
          </b-td>
          <b-td class="text-center">
            {{tratamiento.od}}
          </b-td>
          <b-td class="text-center">
            {{tratamiento.sesion}}
          </b-td>
          <b-td>
            <b-table-simple>
              <b-tbody>
                <b-tr v-for="(pago, indice) in tratamiento.pagos" :key="indice">
                  <b-td>
                    {{pago.nombreForma}}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-td>
          <b-td>
            <b-table-simple>
              <b-tbody>
                <b-tr v-for="(pago, indice) in tratamiento.pagos" :key="indice">
                  <b-td>
                    {{pago.nombreTerminal}}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-td>
          <b-td>
            <b-table-simple>
              <b-tbody>
                <b-tr v-for="(pago, indice) in tratamiento.pagos" :key="indice">
                  <b-td>
                    {{pago.msi}}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-td>
          <b-td>
            <b-table-simple>
              <b-tbody>
                <b-tr v-for="(pago, indice) in tratamiento.pagos" :key="indice">
                  <b-td>
                    {{pago.porcentajeComisionPagamos}}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-td>
          <b-td>
            <b-table-simple>
              <b-tbody>
                <b-tr v-for="(pago, indice) in tratamiento.pagos" :key="indice">
                  <b-td>
                    {{pago.importeComisionPagamos | moneda}}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-td>
          <b-td>
            <b-table-simple>
              <b-tbody>
                <b-tr v-for="(pago, indice) in tratamiento.pagos" :key="indice">
                  <b-td>
                    {{pago.ivaImporteComisionPagamos | moneda}}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
export default {
  name: "DetalleTratamientosReembolsados",
  props: {
    movimiento: Object
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    fields: [
      {key: 'nombre', label: 'Tratamiento'},
      {key: 'nombreForma', label: 'Forma de pago'},
      {key: 'nombreTerminal', label: 'Terminal'},
      {key: 'msi', label: 'MSI'},
      {key: 'porcentajeComisionPagamos', label: '% comisión'},
      {key: 'importeComisionPagamos', label: 'Importe comisión'},
      {key: 'ivaImporteComisionPagamos', label: 'Importe IVA'},
    ],
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
}
</script>

<style scoped>

</style>
